import { uploadSingleFile } from "../files";
import { authClient, API } from "../index";

// Get all juntaDirectiva
export const getJuntaDirectiva = () => {
  return authClient().get(`${API}/juntaDirectiva?getDisabled=true`);
};

// Get juntaDirectiva by id
export const getJuntaDirectivaById = (id) => {
  return authClient().get(`${API}/juntaDirectiva/${id}`);
};

// Delete juntaDirectiva
export const deleteJuntaDirectiva = (id) => {
  return authClient().delete(`${API}/juntaDirectiva/${id}`);
};

// Create juntaDirectiva
export const postJuntaDirectiva = async (juntaDirectiva, selectedImage) => {
  // Solo subir archivos si son instancias de File
  if (selectedImage && selectedImage instanceof File) {
    const response = await uploadSingleFile(selectedImage, "juntaDirectiva");
    juntaDirectiva.foto = response?.data?.fileURL;
  }
  return authClient().post(`${API}/juntaDirectiva`, juntaDirectiva);
};

// Update juntaDirectiva
export const updateJuntaDirectiva = async (id, juntaDirectiva, selectedImage) => {
  // Solo subir archivos si son instancias de File
  if (selectedImage && selectedImage instanceof File) {
    const response = await uploadSingleFile(selectedImage, "juntaDirectiva");
    juntaDirectiva.foto = response?.data?.fileURL;
  }
  return authClient().put(`${API}/juntaDirectiva/${id}`, juntaDirectiva);
};

// Change status juntaDirectiva
export const changeStatusJuntaDirectiva = async (id, active) => {
  return authClient().put(`${API}/juntaDirectiva/change-status/${id}`, { active });
};

// Change order juntaDirectiva
export const changeOrderJuntaDirectiva = async (id, newOrder) => {
  return authClient().put(`${API}/juntaDirectiva/change-order/${id}`, {
    newOrder,
  });
};

